import React from "react";
import PropTypes from "prop-types";
import {TextField} from "@material-ui/core";
import {Controller} from "react-hook-form";

const CustomIntegerInput = ({
    control,
    error,
    name,
    label,
    variant,
    size,
    fullWidth,
    minNumber,
    maxNumber,
    helperText,
}) => {

    const onlyNumbersRegex = new RegExp(/^[0-9]*$/);

    const handleChange = (event, field) => {
        if (event.target.validity.badInput || event.target.validity.rangeUnderflow || event.target.validity.rangeOverflow) {
            event.preventDefault();
            return false;
        }
        field.onChange(event);
    };

    const handleKeyPress = (event) => {
        if (!onlyNumbersRegex.test(event.key)) {
            event.preventDefault();
            return false;
        }
    };

    return (
        <Controller
            name={name}
            control={control}
            rules={{
                required: true,
                min: minNumber,
                max: maxNumber,
            }}
            render={({field}) => (
                <TextField
                    {...field}
                    type="number"
                    label={label}
                    InputProps={{inputProps: {required: true, min: minNumber, max: maxNumber}}}
                    variant={variant}
                    size={size}
                    id={name}
                    fullWidth={fullWidth}
                    error={error}
                    helperText={helperText}
                    onChange={(e) => handleChange(e, field)}
                    onKeyPress={(e) => handleKeyPress(e)}
                />
            )}
        />
    );
};

CustomIntegerInput.defaultProps = {
    fullWidth: false,
    variant: "outlined",
    minNumber: 1,
};

CustomIntegerInput.propTypes = {
    control: PropTypes.object,
    error: PropTypes.any,
    name: PropTypes.string,
    label: PropTypes.string,
    minNumber: PropTypes.number,
    maxNumber: PropTypes.number,
    variant: PropTypes.oneOf(["filled", "outlined", "standard"]),
    size: PropTypes.oneOf(["small", "medium", "large"]),
    type: PropTypes.string,
    fullWidth: PropTypes.bool,
    helperText: PropTypes.string,
    onChange: PropTypes.func,
};

export default CustomIntegerInput;
